module.exports = __webpack_public_path__ + "img/tag.81563242.png";